export default [
	'CONFLICT',
	'STARTED',
	'PENDING',
	'WAITING',
	'OPENED'
]
